import React, { useContext } from 'react';

import { useDispatch } from 'react-redux';
import { DELETE_QUIZ_ASSIGNMENT } from '../../Reducers/Actions';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';
import { useDeleteQuizAssignmentMutation } from '../../services/SkillsManagement';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MuiDialog from '../../SystemDesign/MuiDialog';

const DeleteQuizAssignement = ({ row }) => {
  const dispatch = useDispatch();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
  const [deleteAssignment, { isLoading }] = useDeleteQuizAssignmentMutation();

  const assignment = row?.original || {};
  const id = assignment.assignmentId ?? assignment.id;
  if (!id) return null;

  const handleConfirmDelete = async () => {
    try {
      const res = await deleteAssignment({ assignmentId: Number(id) }).unwrap();
      dispatch({ type: DELETE_QUIZ_ASSIGNMENT, assignmentId: Number(id) });

      const message =
        (res && typeof res === 'object' && (res.message || res?.data?.message)) ||
        'Assignment deleted successfully';
      setInfoAlert({ severity: 'success', message });
      setOpenSnackBar(true);
      // Notify lists to refresh immediately
      try { window.dispatchEvent(new CustomEvent('quiz-assignments:changed')); } catch {}
      return true;
    } catch (err) {
      const message =
        err?.data?.message || err?.message || 'Failed to delete assignment';
      setInfoAlert({ severity: 'error', message });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <DeleteIcon fontSize="small" color="error" />
      </ListItemIcon>
      <ListItemText>Delete</ListItemText>
    </MenuItem>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to delete assignment {id}?</p>
      <p>This action is irreversible.</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<DeleteOutlineIcon />}
      triggerButton={triggerButton}
      title="Delete Assignment"
      subtitle={`You are about to delete assignment ${id}`}
      content={dialogContent}
      maxWidth="xs"
      existAction={true}
      actionTitle="Delete"
      actionFunction={handleConfirmDelete}
      isLoading={isLoading}
    />
  );
};

DeleteQuizAssignement.menuIcon = <DeleteOutlineIcon fontSize="small" />;
DeleteQuizAssignement.menuLabel = 'Delete';

export default DeleteQuizAssignement;